import React from 'react';

interface Props {
	date: string;
	text: string;
	link: string;
	location: string;
}

const Slide: React.FC<Props> = (props) => {
	const {
		date, text, link, location,
	} = props;

	return (link
		? (
			<a href={link} className="slide">
				<span>
					<p>
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
							<path
								d="M19.2 8V11.2M12.8 8V11.2M8.80005 14.4H23.2M10.4 9.6H21.6C22.4837 9.6 23.2 10.3163 23.2 11.2V22.4C23.2 23.2837 22.4837 24 21.6
								24H10.4C9.51639 24 8.80005 23.2837 8.80005 22.4V11.2C8.80005 10.3163 9.51639 9.6 10.4 9.6Z"
								stroke="#5D4493"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
						{date}
					</p>
					<h3>
						{text}
					</h3>
					<p>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path
								d="M12 3C8.13997 3 5 6.19642 5 10.125C5 15.3814 11.4584 21.6289 11.7334 21.8925C11.8086 21.964 11.9043 22 12 22C12.0957 22 12.1914 21.964
								12.2666 21.8925C12.5416 21.6289 19 15.3814 19 10.125C19 6.19642 15.86 3 12 3ZM12 14.0833C9.85578 14.0833 8.1111 12.3075 8.1111 10.125C8.1111
								7.94249 9.85581 6.16665 12 6.16665C14.1442 6.16665 15.8889 7.94252 15.8889 10.125C15.8889 12.3075 14.1442 14.0833 12 14.0833Z"
								fill="#5D4493"
							/>
						</svg>
						{location}
					</p>
				</span>
			</a>
		)
		: (
			<span className="slide">
				<span>
					<p>
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
							<path
								d="M19.2 8V11.2M12.8 8V11.2M8.80005 14.4H23.2M10.4 9.6H21.6C22.4837 9.6 23.2 10.3163 23.2 11.2V22.4C23.2 23.2837 22.4837 24 21.6
								24H10.4C9.51639 24 8.80005 23.2837 8.80005 22.4V11.2C8.80005 10.3163 9.51639 9.6 10.4 9.6Z"
								stroke="#5D4493"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
						{date}
					</p>
					<h3>
						{text}
					</h3>
					<p>
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path
								d="M12 3C8.13997 3 5 6.19642 5 10.125C5 15.3814 11.4584 21.6289 11.7334 21.8925C11.8086 21.964 11.9043 22 12 22C12.0957 22 12.1914 21.964
								12.2666 21.8925C12.5416 21.6289 19 15.3814 19 10.125C19 6.19642 15.86 3 12 3ZM12 14.0833C9.85578 14.0833 8.1111 12.3075 8.1111 10.125C8.1111
								7.94249 9.85581 6.16665 12 6.16665C14.1442 6.16665 15.8889 7.94252 15.8889 10.125C15.8889 12.3075 14.1442 14.0833 12 14.0833Z"
								fill="#5D4493"
							/>
						</svg>
						{location}
					</p>
				</span>
			</span>
		)
	);
};

export default Slide;
